module.exports = __webpack_public_path__ + "04_short_gold.6a329791.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_short_gold.png
// module id = QNWl
// module chunks = 0